"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvCons = exports.EnvNull = void 0;
function EnvNull() {
    return {
        "@kind": "EnvNull",
    };
}
exports.EnvNull = EnvNull;
function EnvCons(name, value, rest) {
    return {
        "@kind": "EnvCons",
        name,
        value,
        rest,
    };
}
exports.EnvCons = EnvCons;
//# sourceMappingURL=Env.js.map